import React from 'react';
import imageImg from 'assets/images/icn-image.svg';

export const InputBox = (props) => {
  const { styles, handleChange, data, name, min, max, submitted, placeholder, type, readOnly, icon, error, notRequired, className } = props;
  // if (name === 'IDIssueDate') {
  //   debugger;
  // }
  return (
    <div className={styles.LoginPage__formBox}>
      <input
        type={type}
        placeholder={placeholder}
        readOnly={readOnly}
        maxLength={max}
        minLength={min}
        defaultValue={data}
        name={name}
        onChange={(e) => handleChange(e)}
        autoComplete="none"
        className={className}
      />
      {icon === 'image' && <img src={imageImg} className={styles.LoginPage__formBoxImage} />}
      {submitted && !data && !notRequired && <div className={styles.LoginPage__error}>{placeholder} is required</div>}
      {error && <div className={styles.LoginPage__error}>{error}</div>}
    </div>
  );
};
